import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_GCP_SECRET_MANAGER,
  GET_GCP_SECRET_MANAGER_SUCCESS,
  GET_GCP_SECRET_MANAGER_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  gcpSecretManagerList: null,
  error: null,
};

export function GCPSecretManagerStore(state = initialState, action) {
  switch (action.type) {
    case GET_GCP_SECRET_MANAGER:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_GCP_SECRET_MANAGER_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        gcpSecretManagerList: action.data,
        error: null,
      };
    case GET_GCP_SECRET_MANAGER_ERROR:
      return { ...state, phase: ERROR, error: action.error };
    default:
      return state;
  }
}
